import { typographyStyles } from "@newsela/angelou";

import { SmallScreenPanelZIndex } from "@/view/ContentLayout/ContentLayout.style";
const { textXSObj } = typographyStyles;

export const toolTipWrapperCss = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
};

const bodyTextCss = {
  ...textXSObj,
  lineHeight: "16px",
};

export const toolTipCss = {
  dialog: {
    body: bodyTextCss,
    root: {
      zIndex: SmallScreenPanelZIndex + 2,
    },
  },
};
